import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import format from 'string-template';

import { PrimaryButton } from '../../../../components/Button/ActionButtons';
import UserActionItem, { ActionItemStatus, ActionItemType } from '../../../Model/UserActionItem';
import {
  ItemCard,
  CardRow,
  UnreadDot,
  CardContent,
  CardTitle,
  CardMessage,
  CardTimestamp,
  CardFooter,
} from './styles';
import texts from './texts.json';

const ActionItemCard = ({
  item,
  onAction,
  onDismiss,
  isDismissing,
}) => {
  const isRead = item.status === ActionItemStatus.READ;

  const getTitle = () => {
    if (item.type === ActionItemType.LEAD_REPLY) {
      return format(texts.leadReply, { leadName: item.leadName });
    }
    return format(texts.leadComment, { username: item.triggerUserName });
  };

  return (
    <ItemCard onClick={onAction}>
      <CardRow>
        <UnreadDot $visible={!isRead} />
        <CardContent>
          <CardTitle>{getTitle()}</CardTitle>
          <CardMessage>{item.message}</CardMessage>
          <CardFooter>
            <CardTimestamp>
              {item.createdAt ? moment(item.createdAt).fromNow() : ''}
            </CardTimestamp>
            {isDismissing ? (
              <CircularProgress size={16} />
            ) : (
              <PrimaryButton
                size="small"
                variant="light"
                $fitToContent
                onClick={(e) => {
                  e.stopPropagation();
                  onDismiss();
                }}
              >
                {texts.markAsResolved}
              </PrimaryButton>
            )}
          </CardFooter>
        </CardContent>
      </CardRow>
    </ItemCard>
  );
};

ActionItemCard.propTypes = {
  item: PropTypes.instanceOf(UserActionItem).isRequired,
  onAction: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  isDismissing: PropTypes.bool.isRequired,
};

export default ActionItemCard;
